/**
 * <s-sticky-atc>: shows the sticky add-to-cart card once the page's main add-to-cart row
 * ([data-main-atc]) has scrolled above the viewport, and hides it again when the row is back
 * in view or the footer is reached.
 */
class StickyAtc extends HTMLElement {
  #observer = null;
  #mainOut = false;
  #footerIn = false;

  connectedCallback() {
    const main = document.querySelector('[data-main-atc]');
    if (!main) return;
    const footer = document.querySelector('footer');
    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === main) this.#mainOut = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (entry.target === footer) this.#footerIn = entry.isIntersecting;
      }
      this.hidden = !(this.#mainOut && !this.#footerIn);
    });
    this.#observer.observe(main);
    if (footer) this.#observer.observe(footer);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', StickyAtc);
